import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faCalendar,
  faCommentDots,
  faComments,
  faNoteMedical,
  faNotebook,
  faSquareList,
  faUsers,
} from "@fortawesome/pro-regular-svg-icons";

import { getHasFeature } from "utils/features";
import { Feature } from "utils/features/types";

const hasFeature = getHasFeature({});

type EventCardLabel =
  | "new_patients"
  | "new_messages"
  | "appointments_to_schedule"
  | "awaiting_treatment_ready"
  | "new_comments"
  | "pending_treatment_activity_logs"
  | "unsigned_care_events";

type Card = {
  label: EventCardLabel;
  icon: IconDefinition;
  link: string;
  dataTestId: string;
};

export const cards: Card[] = [
  {
    label: "new_patients",
    icon: faUsers,
    link: "/patients?filter=new_patients",
    dataTestId: "event-card-new_patients",
  },
  { label: "new_messages", icon: faComments, link: "/messages", dataTestId: "event-card-new_messages" },
  {
    label: "appointments_to_schedule",
    icon: faCalendar,
    link: "/patients?filter=appointment_to_schedule",
    dataTestId: "event-card-appointments_to_schedule",
  },
  ...(hasFeature(Feature.SHOW_AWAITING_TREATMENT_READY)
    ? [
        {
          label: "awaiting_treatment_ready" as const,
          icon: faSquareList,
          link: "/patients?filter=awaiting_treatment_ready",
          dataTestId: "event-card-create_usercourse",
        },
      ]
    : []),
  {
    label: "new_comments",
    icon: faCommentDots,
    link: "/patients?filter=new_comments",
    dataTestId: "event-card-new_comments",
  },
  {
    label: "unsigned_care_events",
    icon: faNoteMedical,
    link: "/dashboard#unsigned-medical-note-table",
    dataTestId: "event-card-unsigned_care_events",
  },
  {
    label: "pending_treatment_activity_logs",
    icon: faNotebook,
    link: "/dashboard#activity-logs-table",
    dataTestId: "event-card-pending_treatment_activity_logs",
  },
];
